
import React, { useMemo } from "react";
import { SafeAreaView, TouchableOpacity, View } from "react-native";
import { useTranslation } from "react-i18next";
import { useNavigation } from "@react-navigation/native";
import { CustomIcon } from "../components/CustomIcon";
import { Text } from "react-native-paper";
import { signInWithGoogle } from "../services/authService";
import getGlobalStyles from '../globalStyles';
import { useThemeSettings } from "../ThemeProvider";
import { useCallback, useEffect } from "react";
import { useUserStore } from "../store/userStore";
import AnimatedScreen from "../components/AnimatedScreen";
import { ROUTES } from "../shared/constants/routes";
import { TabNavigationProp } from "../shared/types/RootStackParamList";
import { useTrackScreenTime } from "../analytics/useTrackScreenTime";
import { ModalType, useModalStore } from "../store/modalStore";
import { useCollectionStore } from "../store/collectionStore";

export const Login = () => {
  useTrackScreenTime(ROUTES.LOGIN)
  const { user, setUser } = useUserStore();
  const { theme } = useThemeSettings();
  const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);
  const { t } = useTranslation();
  const navigation = useNavigation<TabNavigationProp>();
  const setModalShown = useModalStore((s) => s.setModalShown);
  const { collectionList } = useCollectionStore();

  useEffect(() => {
    if (user && user?.thinkoUser && user?.thinkoUser?.provider !== 'anonymous') {
      setTimeout(() => {
        onLoggedIn()
      }, 100);
    }
  }, [user])
  const onLoggedIn = useCallback(() => {
    (navigation as any).navigate(ROUTES.HOME);
  }, []);

  const showPopupBlockedModal = () => {
    setModalShown(ModalType.CONFIRM, {
      type: "info",
      title: "Sign-in popup blocked",
      header: "Your browser blocked the Google sign-in window.",
      message: "Please allow popups and try again.",
    });
  };
  
  const handleGoogleLogin = async () => {
    const hasCustomCollections =
      collectionList?.some((c) => !c.is_thinko);
  
    // If user has created data → require confirmation first
    if (hasCustomCollections) {
      setModalShown(ModalType.CONFIRM, {
        title: "You’re currently browsing as a guest.",
        header: "If you continue, signing in will replace this session.",
        message:
          "Your future activity will be saved to your account. Do you want to proceed?",
        onConfirm: async () => {
          setModalShown(ModalType.NONE);
  
          const result = await signInWithGoogle(true);
          if (result === "OK" || result === "ACCOUNT_PRESENT") {
            onLoggedIn();
          } else if (result === "POPUP_BLOCKED") {
            showPopupBlockedModal();
          }
        },
      });
  
      return;
    }
  
    // No user data → safe to auto-upgrade immediately
    const result = await signInWithGoogle(true);
  
    if (result === "OK" || result === "ACCOUNT_PRESENT") {
      onLoggedIn();
    } else if (result === "POPUP_BLOCKED") {
      showPopupBlockedModal();
    }
  };

  const redirectComingSoon = useCallback(() => {
    navigation.navigate(ROUTES.TBD);
  }, []);
  const providers = [
    {
      icon: 'google',
      label: t("screens.login.google"),
      onPress: handleGoogleLogin,
      bgColor: theme?.colors?.white,
      color: theme?.colors.black
    },/* 
    {
      icon: 'apple',
      label: t("screens.login.apple"),
      onPress: redirectComingSoon,
      bgColor: theme?.colors?.black,
      color: theme?.colors?.white
    } */
  ]
  return (
    <AnimatedScreen>
      <SafeAreaView style={{ flex: 1, alignItems: 'center' }}>
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>

          <CustomIcon icon="thinko-full" size={120} />
          {providers.map((p) => {
            return <TouchableOpacity key={p.icon}
              style={[gStyles.fullWidthButton, { backgroundColor: p.bgColor }]}
              onPress={p?.onPress}
            >
              <CustomIcon icon={p.icon as any} size={24} />
              <Text style={[gStyles?.header2, { color: p.color }]}>{p.label}</Text>
            </TouchableOpacity>
          })}
        </View>
       {/*  <View style={{ height: 40, display: 'flex', flexDirection: "row", marginBottom:60 }}>
          <Text style={gStyles?.header2}>{t("screens.login.signUpMessage")}
          </Text>
          <TouchableOpacity onPress={redirectComingSoon}>
            <Text style={[gStyles?.header2, { color: theme?.colors?.primary }]}>{t("screens.login.signUp")}</Text>
          </TouchableOpacity>
        </View> */}
      </SafeAreaView>
    </AnimatedScreen>
  );
};